// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lvYzP","socialList":"styles_socialList__rNiU1"};